import { Link } from 'react-router-dom';
import { useEffect, useState } from 'react';
import { AppShell } from '../components/AppShell';
import { ActiveSiteBanner } from '../components/ActiveSiteBanner';
import { useUserOrg } from '../lib/org';
import { useCurrentSite } from '../lib/currentSite';
import {
  listPlant,
  listCoshh,
  listTrainingPeople,
  listSubcontractors,
} from '../lib/db';
import { isFeatureEnabled, type FeatureKey } from '../lib/features';

export function Registers() {
  const { org } = useUserOrg();
  const { currentSite } = useCurrentSite();
  const [counts, setCounts] = useState<Record<string, number>>({});

  useEffect(() => {
    if (!org) return;
    (async () => {
      try {
        const [plant, coshh, people, subs] = await Promise.all([
          listPlant(org.org_id),
          listCoshh(org.org_id),
          listTrainingPeople(org.org_id),
          listSubcontractors(org.org_id),
        ]);
        setCounts({
          plant: plant.length,
          coshh: coshh.length,
          training: people.length,
          subbies: subs.length,
          first_aiders: subs.filter((s) => s.first_aider).length,
        });
      } catch {
        /* swallow — counts are decorative */
      }
    })();
  }, [org]);

  const allTiles: { key: string; featureKey: FeatureKey | null; to: string; title: string; sub: string }[] = [
    { key: 'plant',         featureKey: 'plant',           to: '/registers/plant',         title: 'Plant',           sub: 'Owned plant + tools. LOLER and PAT dates.' },
    { key: 'coshh',         featureKey: 'coshh',           to: '/registers/coshh',         title: 'COSHH',           sub: 'Hazardous products on site.' },
    { key: 'training',      featureKey: 'training_matrix', to: '/registers/training',      title: 'Training',        sub: 'Cards and certificates by person.' },
    { key: 'subbies',       featureKey: 'subbies',         to: '/registers/subbies',       title: 'Subcontractors',  sub: 'Auto-populated from inductions.' },
    { key: 'first_aiders',  featureKey: null,              to: '/registers/first-aiders',  title: 'First aiders',    sub: 'Everyone with a current FAW / EFAW certificate.' },
    { key: 'expiries',      featureKey: null,              to: '/registers/expiries',      title: 'Insurances & expiries', sub: 'Everything expiring in the next 30 days.' },
  ];
  const tiles = allTiles.filter((t) => t.featureKey === null || isFeatureEnabled(org, t.featureKey));

  return (
    <AppShell title="Registers" back="/">
      <ActiveSiteBanner site={currentSite} />
      <div className="card" style={{ marginBottom: 12, marginTop: 12 }}>
        <p style={{ margin: 0, color: 'var(--ink-soft)' }}>
          Org-wide registers — shared across all your sites.
        </p>
      </div>

      {tiles.map((t) => (
        <Link key={t.key} to={t.to} className="check-tile">
          <div className="check-tile-text">
            <p className="check-tile-title">
              {t.title}
              {counts[t.key] !== undefined && (
                <span className="count-badge" style={{ marginLeft: 8 }}>{counts[t.key]}</span>
              )}
            </p>
            <p className="check-tile-sub">{t.sub}</p>
          </div>
          <span className="chev">›</span>
        </Link>
      ))}
    </AppShell>
  );
}
